<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.Teams.add") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required/>
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required/>
          <!-- End:: Name Input -->
          <!-- Start:: Sport Input -->
          <base-select-input 
                             col="6" :optionsList="leagueList" :placeholder="$t('SIDENAV.Sports.name')"
                             v-model="data.sport"/>

          <!-- Start:: Sport Input -->
          <base-paginated-select ref="childComponent" :api_sport_id="data.sport?.api_sport_id"
                                 :required="true" type="team"
                                 :placeholder="$t('SIDENAV.Teams.team')"
                                 col="6" v-model.trim="data.api_team_id"
          />
          
          <!--<base-select-input col="6" :optionsList="teamList" :placeholder="$t('SIDENAV.Teams.team')"-->
                             <!--v-model="data.api_team_id"/>-->
          <!-- End:: Sport Input -->
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input col="6" identifier="image" :preSelectedImage="data.image.path"
                                   :placeholder="$t('PLACEHOLDERS.image')" @selectImage="selectImage" required/>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.active" hide-details></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button class="mt-2" styleType="primary_btn" :btnText="$t('BUTTONS.save')"
                         :isLoading="isWaitingRequest"
                         :disabled="isWaitingRequest"/>
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import {debounce} from "lodash";
export default {
  name: "CreateTeams",

  data() {
    return {
      teamList: [],
      leagueList: [],
      total: 10,
      page: 1,
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        sport: null,
        api_team_id: null,
        active: true,
        image: {
          path: null,
          file: null,
        },
      },
      // End:: Data Collection To Send
    };
  },

  computed: {},
  watch: {
    ["data.sport"]: {
      handler() {
        this.debouncedGetCountries();
      },
      immediate: true
    }
  },
  methods: {
    debouncedGetCountries: debounce(function () {
      this.$refs.childComponent.getCountries();
    }, 500),
    async getSports() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sports?page=0&limit=0`,
        });
        this.leagueList = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // async getApiTeam(comeFromChange = false) {
    //   if (comeFromChange) {
    //     this.teamList = [];
    //     this.page = 1;
    //     if (this.cancelTokenSource) {
    //       this.cancelTokenSource.cancel("Request canceled due to new selection.");
    //     }
    //     this.cancelTokenSource = this.$axios.CancelToken.source();
    //   }
    //   if (this.page > this.total) {
    //     return;
    //   }
    //   if (this.page <= this.total) {
    //     try {
    //       let res = await
    //         this.$axios({
    //           method: "GET",
    //           url: `soccer-teams`,
    //           params: {
    //             page: this.page,
    //             sport_id: this.data.sport?.api_sport_id ?? 1,
    //           },
    //         });
    //       console.log(res);
    //       this.teamList = this.teamList.concat(res.data.data.res.data);
    //       this.total = res.data.data.res.meta.pages;
    //       this.page = parseInt(res.data.data.res.meta.page) + 1;
    //     } catch (error) {
    //     }
    //   }
    //   this.getApiTeam();
    // },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.sport) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.sport"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.nameAr);
      REQUEST_DATA.append("name[en]", this.data.nameEn);
      REQUEST_DATA.append("sport_id", this.data.sport?.id ?? null);
      REQUEST_DATA.append("api_team_id", this.data.api_team_id);
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `teams`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({path: "/teams/all"});
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form


  },

  created() {
    this.getSports();
  },
};
</script>
